import { render, staticRenderFns } from "./datum.vue?vue&type=template&id=d9db23e2&scoped=true&"
import script from "./datum.vue?vue&type=script&lang=js&"
export * from "./datum.vue?vue&type=script&lang=js&"
import style0 from "./datum.vue?vue&type=style&index=0&id=d9db23e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9db23e2",
  null
  
)

export default component.exports